import SEOMeta from '@/components/base/SEOMeta';
import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import HeroSection from './components/HeroSection';
import FeaturedArticles from './components/FeaturedArticles';
import CategoryGrid from './components/CategoryGrid';
import FAQSection from './components/FAQSection';
import NewsletterSection from './components/NewsletterSection';

const homepageSchema = {
  '@context': 'https://schema.org',
  '@type': 'WebPage',
  name: '暗网91官方入口·深度解析与安全指南',
  description:
    '暗网91是当前备受关注的深网资源平台，全面解析暗网91的访问方式、安全风险、真实评测及合规使用建议，帮助用户了解暗网91的运作机制，规避潜在威胁，保护个人隐私与数据安全。',
  url: 'https://www.anwang91.com',
  isPartOf: {
    '@type': 'WebSite',
    name: '暗网91安全指南',
    url: 'https://www.anwang91.com',
  },
};

const faqSchema = {
  '@context': 'https://schema.org',
  '@type': 'FAQPage',
  mainEntity: [
    {
      '@type': 'Question',
      name: '暗网91是什么？',
      acceptedAnswer: {
        '@type': 'Answer',
        text: '暗网91是深网中一个知名的信息资源平台，提供信息发布、资源分享和社区讨论等功能。用户可以通过Tor网络匿名访问该平台，获取各类信息资源。',
      },
    },
    {
      '@type': 'Question',
      name: '如何安全访问暗网91？',
      acceptedAnswer: {
        '@type': 'Answer',
        text: '安全访问暗网91需要：安装并正确配置Tor浏览器；通过官方渠道获取最新.onion地址；使用PGP验证地址签名；配置Tor安全级别为"最安全"；建议使用VPN作为前置代理。',
      },
    },
    {
      '@type': 'Question',
      name: '访问暗网是否合法？',
      acceptedAnswer: {
        '@type': 'Answer',
        text: '仅使用Tor浏览器访问暗网本身在大多数国家是合法的。但需要注意：在暗网中进行非法交易或活动是违法的。本站仅提供安全知识学习，请务必遵守当地法律法规。',
      },
    },
    {
      '@type': 'Question',
      name: '暗网91有哪些安全风险？',
      acceptedAnswer: {
        '@type': 'Answer',
        text: '主要安全风险包括：钓鱼网站冒充官方入口、恶意软件通过下载传播、诈骗交易、个人隐私泄露等。通过遵守安全指南和保持警惕，可以有效规避这些风险。',
      },
    },
    {
      '@type': 'Question',
      name: 'Tor浏览器的安全级别如何设置？',
      acceptedAnswer: {
        '@type': 'Answer',
        text: 'Tor浏览器提供标准、较安全和最安全三个级别。访问暗网时建议设置为"最安全"级别，这将禁用JavaScript和部分字体渲染，最大程度保护匿名性。',
      },
    },
    {
      '@type': 'Question',
      name: '暗网91的内容是否可靠？',
      acceptedAnswer: {
        '@type': 'Answer',
        text: '暗网91平台本身不保证所有内容的可靠性。用户需要自行判断信息真伪，参考多方来源进行验证。建议优先关注信誉良好的发布者和经过社区验证的内容。',
      },
    },
  ],
};

export default function Home() {
  return (
    <>
      <SEOMeta
        title="暗网91官方入口·深度解析与安全指南"
        description="暗网91是当前备受关注的深网资源平台，全面解析暗网91的访问方式、安全风险、真实评测及合规使用建议，帮助用户了解暗网91的运作机制，规避潜在威胁，保护个人隐私与数据安全。"
        keywords="暗网91,暗网91入口,暗网91访问教程,暗网安全指南,深网资源平台,暗网隐私保护,Tor匿名访问"
        canonicalUrl="https://www.anwang91.com"
        schemaJson={{ ...homepageSchema, ...faqSchema }}
      />
      <Navbar />
      <main>
        <HeroSection />
        <FeaturedArticles />
        <CategoryGrid />
        <FAQSection />
        <NewsletterSection />
      </main>
      <Footer />
    </>
  );
}